import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import ArrowBack from 'material-ui-icons/ArrowBack'
import IconButton from 'material-ui/IconButton'
import Avatar from '../Avatar'
import AppMenu from '../AppMenu'
import Typography from 'material-ui/Typography'

type Props = {
  title: string,
  pictureUrl?: string,
  subtitle?: string,
  backLink?: string
}

class CouncillorAppBar extends Component<Props> {
  render() {
    const {
      title,
      subtitle,
      backLink,
      pictureUrl
    } = this.props

    return (
      <AppBar position='static'>
        <Toolbar disableGutters>
          {backLink &&
            <IconButton
              component={Link}
              to={backLink}
              color='inherit'
            >
              <ArrowBack />
            </IconButton>
          }

          <div className='flex-auto tr'>
            <AppMenu />
          </div>
        </Toolbar>

        <Avatar
          url={pictureUrl}
          alt={title}
          className='center mb2'
          large
        />

        <Typography
          variant='headline'
          color='inherit'
          align='center'
          gutterBottom
        >
          {title}
        </Typography>

        {subtitle &&
          <Typography
            variant='subheading'
            color='inherit'
            align='center'
            gutterBottom
          >
            {subtitle}
          </Typography>
        }

        <Typography
          variant='subheading'
          color='inherit'
          align='center'
          paragraph
        >
          City Council of Toronto
        </Typography>
      </AppBar>
    )
  }
}

export default CouncillorAppBar



// WEBPACK FOOTER //
// ./src/components/CouncillorAppBar/CouncillorAppBar.js